import type { JSX } from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../auth/useAuth";
import FullScreenLoading from "../components/common/FullScreenLoading";

export default function AdminRoute({ children }: { children: JSX.Element }) {
  const { data, isLoading } = useAuth();

  if (isLoading) {
    return <FullScreenLoading />; // prevent redirect until auth check finishes
  }

  if (!data?.user) {
    return <Navigate to="/login" />;
  }

  if (!data.isAdmin && !data.isPower && !data.isSuper) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
}
